import { render, staticRenderFns } from "./roleTree.vue?vue&type=template&id=b9bab76c&scoped=true"
import script from "./roleTree.vue?vue&type=script&lang=js"
export * from "./roleTree.vue?vue&type=script&lang=js"
import style0 from "./roleTree.vue?vue&type=style&index=0&id=b9bab76c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bab76c",
  null
  
)

export default component.exports